import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';

export function mapRepairRequestMeta(detail) {
  return {
    code: detail?.repairRequestNo || '-',
    status: detail?.status || '',
    repairRequestDate: formatDateOrDash(detail?.repairRequestDate),
    remark: detail?.remark || '',
    customerName: detail?.customerName || '',
    contactName: detail?.contactName || '',
    phone: detail?.phone || '',
    fax: detail?.fax || '',
    taxId: detail?.taxId || '',
    address: detail?.address || '',
    receivedDate: formatDateOrDash(detail?.receivedDate),
    createDate: formatDateTimeOrDash(detail?.record?.createdAt),
    reviseDate: formatDateTimeOrDash(detail?.record?.updatedAt),
    establishedAt: formatDateTimeOrDash(detail?.history?.establishedAt),
    completedAt: formatDateTimeOrDash(detail?.history?.completedAt),
    lineCount: detail?.itemCount ?? detail?.lines?.length ?? 0,
  };
}
